export default{
  network:{
    // host: "https://test-mis.distinctclinic.com/app-web2/news/",
    host: "https://app.distinctclinic.com/app-web2/news/",
    v2host: "https://app.distinctclinic.com/app-web2/psa/",
    baseHost: 'https://app.distinctclinic.com/',
  }
}



// WEBPACK FOOTER //
// ./src/common.js